import { render, staticRenderFns } from "./TmzOtherReports.vue?vue&type=template&id=2a219c64&scoped=true&"
import script from "./TmzOtherReports.vue?vue&type=script&lang=js&"
export * from "./TmzOtherReports.vue?vue&type=script&lang=js&"
import style0 from "./TmzOtherReports.vue?vue&type=style&index=0&id=2a219c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a219c64",
  null
  
)

export default component.exports